export default __webpack_public_path__ + "static/media/KanzleiPilotLogo.6dbe6416.svg";